import { dispatchPromise, fetchResources } from './action-helpers';

export const fetchNotifications = (fetchProps, all) => fetchResources('NOTIFICATIONS_FETCH_REQUESTED', fetchProps, all);

export const removeNotifications = notificationIds => {
    if (!notificationIds.length) {
        return Promise.resolve();
    }

    return dispatchPromise({
        type: 'NOTIFICATIONS_REMOVE_REQUESTED',
        payload: { notificationIds }
    });
}

export const readNotifications = notificationIds => {
    if (!notificationIds.length) {
        return Promise.resolve();
    }

    return dispatchPromise({
        type: 'NOTIFICATIONS_READ_REQUESTED',
        payload: { notificationIds }
    });
}

export const unreadNotifications = notificationIds => {
    if (!notificationIds.length) {
        return Promise.resolve();
    }

    return dispatchPromise({
        type: 'NOTIFICATIONS_UNREAD_REQUESTED',
        payload: { notificationIds }
    });
}

export const readAllNotifications = () => {
    return dispatchPromise({
        type: 'NOTIFICATIONS_READ_ALL_REQUESTED'
    });
}

export const resetNotifications = () => {
    return dispatchPromise({
        type: 'NOTIFICATIONS_RESET_REQUESTED'
    });
}

export const fetchTeamsNotificationCount = all => fetchResources('TEAMS_NOTIFICATION_COUNT_FETCH_REQUESTED', {}, all);
